'use strict'

import React        from 'react'
import moment       from 'moment'
import DatePicker   from 'react-datepicker'
import CalendarIcon from '../assets/calendar-icon'

export default class PaymentDetails extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      cardTypes: ['Visa', 'MasterCard'],
      cardNumbers: ['', '', '', ''],
      cardExpiry: ['', ''],
      datePicked: null
    }
  }

  componentDidMount () {
    const {summary} = this.props

    const payment = parseInt(summary['dental-package'].weeklyPayment.replace(/[^\d]/g, ''))
    const minFortnight = 79

    payment <= minFortnight && this.updatePaymentFrequency('Weekly')
  }

  updatePaymentFrequency (val) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Payment - Interaction'
    })

    this.props.onChange('payment-frequency', {
      displayName: 'Payment Frequency',
      value: val,
      pageRef: 'your-preference',
      order: 8,
      displayInSummary: true
    })
  }

  updateCardType (e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Payment - Interaction'
    })

    this.props.onChange('card-type', {
      displayName: 'Card Type',
      value: e.target.value,
      pageRef: 'your-preference',
      order: 9
    })
  }

  updateCardNumber (i, e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Payment - Interaction'
    })

    let {cardNumbers} = this.state

    cardNumbers[i] = e.target.value

    this.props.onChange('card-number', {
      displayName: 'Card Number',
      value: cardNumbers,
      pageRef: 'your-preference',
      order: 10
    })

    this.setState({cardNumbers})
  }

  updateCardExpiry (i, e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Payment - Interaction'
    })

    let {cardExpiry} = this.state

    cardExpiry[i] = e.target.value

    this.props.onChange('card-expiry', {
      displayName: 'Card Expiry',
      value: cardExpiry,
      pageRef: 'your-preference',
      order: 12
    })

    this.setState({cardExpiry})
  }

  updateFirstPaymentDate (e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Payment - Interaction'
    })

    this.props.onChange('first-payment-date', {
      displayName: 'First Payment Date',
      value: e.format('DD/MM/YY'),
      pageRef: 'your-preference',
      order: 13,
      displayInSummary: true
    })

    this.setState({
      datePicked: e
    })
  }

  render () {
    const {cardTypes, cardNumbers, datePicked, cardExpiry} = this.state
    const {summary} = this.props

    const payment = parseInt(summary['dental-package'].weeklyPayment.replace(/[^\d]/g, ''))
    const minFortnight = 79

    return (
      <div>
        <section className='payment-details'>
          <h2 className='header'>Payment Details</h2>
          <div>
            <div
              style={{display: payment <= minFortnight ? 'none' : 'block'}}
              className='input-row'>
              <span className='item-title two-fifths-width bold'>I would prefer to pay</span>
              <div className='three-fifths-width flex-wrapper-column'>
                <div className='payment-frequency flex-wrapper flex-items '>
                  <input
                    type='radio'
                    id='payment-frequency_weekly'
                    className='payment-frequency_Input'
                    name='payment-frequency'
                    onClick={this.updatePaymentFrequency.bind(this, 'Weekly')}
                    defaultChecked={payment <= minFortnight || (summary['payment-frequency'] && summary['payment-frequency'].value === 'Weekly')} />
                  <label htmlFor='payment-frequency_weekly'>
                    Weekly <span className='primary-color-text'>{summary['dental-package'] && summary['dental-package'].weeklyPayment}</span>
                  </label>
                </div>
                <div
                  className='payment-frequency flex-wrapper flex-items '>
                  <input
                    type='radio'
                    id='payment-frequency_fortnight'
                    className='payment-frequency_Input'
                    name='payment-frequency'
                    onClick={this.updatePaymentFrequency.bind(this, 'Fortnightly')}
                    disabled={payment <= minFortnight}
                    defaultChecked={summary['payment-frequency'] && summary['payment-frequency'].value === 'Fortnightly'} />
                  <label htmlFor='payment-frequency_fortnight'>
                    Fortnightly <span className='primary-color-text'>{summary['dental-package'] && summary['dental-package'].fortnightlyPayment}</span>
                  </label>
                </div>
              </div>
            </div>
            <div className='input-row'>
              <span className='item-title two-fifths-width bold'>Credit card type</span>
              <ul className='three-fifths-width card-type-list flex-wrapper-column'>
                {cardTypes.map((cardType) => {
                  const id = 'card-type_' + cardType
                  const image = 'card-type_Image_' + cardType
                  const input = 'card-type_Input_' + cardType
                  return (
                    <li key={cardType} className={'flex-wrapper flex-items card-type_Image' + ' ' + image}>
                      <input
                        type='radio'
                        id={id}
                        className={input}
                        name='card-type'
                        value={cardType}
                        onChange={this.updateCardType.bind(this)}
                        defaultChecked={summary['card-type'] && summary['card-type'].value === cardType} />
                      <label htmlFor={id}>
                        {cardType}
                      </label>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className='input-row'>
              <span className='item-title two-fifths-width'>Credit card number</span>
              <div className='three-fifths-width credit-card-input'>
                {cardNumbers.map((key, i) => {
                  return (
                    <input
                      key={i}
                      className='one-quarter-width align-center credit-card-number required'
                      type='text'
                      maxLength='4'
                      value={key}
                      onChange={this.updateCardNumber.bind(this, i)}
                      defaultValue={summary['card-number'] ? summary['card-number'].value[i] : ''} />
                  )
                })}
              </div>
            </div>
            <div className='input-row'>
              <span className='item-title two-fifths-width'>Expiry Date</span>
              <div className='three-fifths-width credit-card-input'>
                {cardExpiry.map((key, i) => {
                  return (
                    <input
                      key={i}
                      className='one-quarter-width align-center credit-card-expiry required'
                      type='text'
                      maxLength='2'
                      placeholder={i ? 'YY' : 'MM'}
                      value={key}
                      onChange={this.updateCardExpiry.bind(this, i)}
                      defaultValue={summary['card-expiry'] ? summary['card-expiry'].value[i] : ''} />
                  )
                })}
              </div>
            </div>
            <div className='input-row'>
              <span className='item-title two-fifths-width'>Preferred Start Date</span>
              <div className='three-fifths-width'>
                <div className='half-width relative'>
                  <DatePicker
                    dateFormat='DD/MM/YY'
                    selected={datePicked}
                    placeholderText='Click to select a date'
                    minDate={moment().add(1, 'day')}
                    onChange={this.updateFirstPaymentDate.bind(this)}
                    defaultValue={summary['first-payment-date'] ? summary['first-payment-date'].value : ''} />
                  <CalendarIcon />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/payment-details.js